module.exports = __webpack_public_path__ + "5412cebf39c4fbc831fbcdcc613bc531.png";